import { useEffect, useState } from "react";
import IconMenu2, { ActionType } from "../../icon-menu-2.component";
import { PostDocument, PostImage } from "../post-card.component";

import cx from "classnames";
import moment from "moment";
import { Remarkable } from "remarkable";
import useLang from "../../../hooks/use-lang.hook";
import useModel from "../../../hooks/use-model.hook";
import { endpoints } from "../../../_config";
import { createPostDetailPageRouteFromSlug } from "../../../_pages/post-detail.page";
import { PostService } from "../../../_service";
import { formatTime } from "../../../_utils/formatTime-util";
import { ActionModal } from "../../action-modal.component";
import CustomDropDown from "../../atoms/custom-dropdown";
import I18 from "../../atoms/i18";
import { Avatar } from "../../avatar.component";
import EmojiPicker from "../../form-controls/emoji-picker.component";
import IconButton2 from "../../icon-button-2-component";
import IconButton from "../../icon-button.component";
import { Loader } from "../../loader.component";
import ReportModal from "../../report-modal.component";
import UIcon from "../../uicon-component";
import CreateComment from "./create-comment";
const md = new Remarkable();

/**
 * Component to show a post comment
 * @param {*} param0
 * @returns
 */
export function PostComment({
  post,
  user,
  group,
  comment,
  postId,
  updatePost,
  updateComment,
  addToast,
  community,
}) {
  const imageFormat = ["png", "jpg", "jpeg", "gif"];
  const lang = useLang();

  const [isProcessing, setIsProcessing] = useState(false);
  const [subCommentView, setSubCommentView] = useState(false);
  const [commentRepliesArr, setCommentRepliesArr] = useState([]);
  //opening delete confirmation tab
  const [visibleDeleteComment, setVisibleDeleteComment] = useState(false);
  const [commentImageToBePreviewed, setCommentImageToBePreviewed] =
    useState(false);
  const [selectedEmoji, setSelectedEmoji] = useState(null);
  const [isEmojiPickerVisible, setIsEmojiPickerVisible] = useState(false);

  // passing handlers to report modal
  const [active, setActive] = useState(false);
  const [displayClosePrompt, setDisplayClosePrompt] = useState(false);

  const {
    profileModelState: { setShowProfileModel, setIdToViewProfile },
  } = useModel();

  useEffect(() => {
    setCommentRepliesArr(comment.replies ? comment.replies : []);
  }, [comment.replies]);

  const showSubComment = () => {
    setSubCommentView(!subCommentView);
  };

  const onCommentUpdate = (commentReply) => {
    let newSubCommentArr = [...commentRepliesArr, commentReply];
    setCommentRepliesArr(newSubCommentArr);
    setSubCommentView(true);
  };

  // handle react to commnet
  const handleReactToComment = (emoji) => {
    PostService.addCommentReaction(user, postId, comment.id, emoji)
      .then(({ comment }) => {
        // update comment
        updateComment(comment);
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  // handle react to commnet
  const handleRemoveReactToComment = () => {
    PostService.removeCommentReaction(user, postId, comment.id)
      .then(({ comment }) => {
        // update comment
        updateComment(comment);
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  const onSubCommentDelete = (commentReply) => {
    let updatedSubCommentArr = commentRepliesArr.filter(
      (re) => re.id !== commentReply.id
    );
    setCommentRepliesArr(updatedSubCommentArr);
  };

  useEffect(() => {
    const cb = (e) => {
      setCommentImageToBePreviewed(e.target.src);
    };

    document
      .querySelectorAll("#PostComment PostImages PostImage img")
      .forEach((img) => {
        img.addEventListener("click", cb);
      });

    return () => {
      document
        .querySelectorAll("#PostComment PostImages PostImage img")
        .forEach((img) => {
          img.removeEventListener("click", cb);
        });
    };
  }, [post]);

  const sample = moment
    .duration(moment(new Date()).diff(moment(comment.createdAt)))
    .asDays();

  const postCommentDomId = comment.id ? "PostComment_" + comment.id : null;

  /**
   * Enable copy button on pre code parent
   */
  useEffect(() => {
    if (postCommentDomId) {
      const codeElemeents = document.querySelectorAll(
        `#${postCommentDomId} pre>code`
      );
      codeElemeents.forEach((codeElement) => {
        const preElement = codeElement.parentElement;
        preElement.style.position = "relative";
        const copyButtonElement = document.createElement("span");
        copyButtonElement.style.position = "absolute";
        copyButtonElement.style.top = "0px";
        copyButtonElement.style.right = "5px";
        copyButtonElement.style.cursor = "pointer";
        copyButtonElement.innerText = "Copy";
        copyButtonElement.onclick = async () => {
          try {
            await navigator.clipboard.writeText(codeElement.innerText);
            return;
          } catch (error) {
            console.error("Cannot copy to clipboard, trying legacy");
          }
          const copyElem = document.createElement("textarea");
          copyElem.value = codeElement.innerText;
          document.body.appendChild(copyElem);
          copyElem.select();
          document.execCommand("copy");
          document.body.removeChild(copyElem);
          addToast("Copied to clipboard");
        };
        preElement.appendChild(copyButtonElement);
      });
    }
  }, [comment.description]);

  return comment.isProhibited && !comment.isUnblockable ? (
    <>
      <div className="flex">
        <div className="mt-3">
          <div className="cursor-disabled">
            <Avatar
              user={{
                name: "Unknown",
                picture: endpoints.misc.defaultImageFromBackendUrl,
              }}
              showDetailsOnHover
              noName
              onClick={(e) => {}}
            />
          </div>
        </div>
        <div className="PostComment my-2 w-full rounded bg-background pl-3 pt-1">
          <span className="text-xs text-secondary-foreground/70">
            This content is not available to you
          </span>
        </div>
      </div>
    </>
  ) : (
    <>
      {commentImageToBePreviewed &&
      imageFormat.includes(commentImageToBePreviewed.split(".").pop()) ? (
        <div
          className="PostImageFullPreview"
          onClick={(e) => {
            setCommentImageToBePreviewed(null);
          }}>
          <div className="holder">
            <img src={commentImageToBePreviewed} alt="Preview" loading="lazy" />
            <IconButton
              icon="plus"
              rotate={45}
              className="close-button"
              onClick={(e) => {
                setCommentImageToBePreviewed(null);
              }}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="flex">
        <div className="mt-3">
          <div className="cursor-pointer">
            <Avatar
              user={comment.createdBy}
              noName
              onClick={(e) => {
                // window.open(
                //   createUserWallPageRoute(comment.createdBy.id, "activity")
                // );
                setIdToViewProfile(comment.createdBy.id);
                setShowProfileModel(true);
              }}
            />
          </div>
          {subCommentView ? (
            <div className="avatar-thread-border ml-4 mt-3 border-l-2 border-border"></div>
          ) : (
            <></>
          )}
        </div>
        <div key={comment.id} id={postCommentDomId} className="my-1 w-full">
          <div className="flex items-center justify-between">
            <div className="">
              <Avatar
                user={comment.createdBy}
                extraInfo={formatTime(comment.createdAt)}
                noPicture
                showSubtitle={true}
                showDotSeperator={true}
                size={36}
                className="cursor-pointer"
                onClick={(e) => {
                  // window.open(
                  //   createUserWallPageRoute(comment.createdBy.id, "activity")
                  // );
                  setIdToViewProfile(comment.createdBy.id);
                  setShowProfileModel(true);
                }}
              />
            </div>
            {/* reporting modal */}
            <ReportModal
              contentLink={
                window.location.origin + createPostDetailPageRouteFromSlug(post)
              }
              community={community}
              addToast={addToast}
              activeProps={{ active, setActive }}
              displayProps={{ displayClosePrompt, setDisplayClosePrompt }}
              content={"post-comment: description: " + comment.description}
            />
            <IconMenu2
              icon="menu-dots"
              actions={[
                {
                  icon: "trash",
                  label:
                    (user &&
                      comment.createdBy &&
                      comment.createdBy.id === user.id) ||
                    post.canDeleteComment
                      ? "Delete"
                      : "",
                  onClick: (e) => {
                    setIsProcessing(true);
                    setVisibleDeleteComment(true);
                    setIsProcessing(false);
                  },
                  actionType: ActionType.alert,
                },
                {
                  // report comment
                  icon: "flag",
                  label: "Report",
                  onClick: (e) => {
                    // add the function to report comment
                    setActive(true);
                  },
                },
              ]}
              hideOnEmpty
            />
            <ActionModal
              active={visibleDeleteComment}
              setActive={setVisibleDeleteComment}
              header="Delete Comment"
              title="Are you sure you want to delete this comment?"
              onSubmit={(e) => {
                // Optimistically remove the comment so moderation feels instant,
                // even while the (slower) server delete is still in flight. The
                // whole-post re-decoration the server returns is ignored.
                const previousPost = post;
                setVisibleDeleteComment(false);
                updatePost({
                  ...post,
                  comments: Array.isArray(post.comments)
                    ? post.comments.filter((c) => c.id !== comment.id)
                    : post.comments,
                  commentCount:
                    typeof post.commentCount === "number" &&
                    post.commentCount > 0
                      ? post.commentCount - 1
                      : post.commentCount,
                  latestComment:
                    post.latestComment && post.latestComment.id === comment.id
                      ? null
                      : post.latestComment,
                });
                addToast("Comment deleted!");
                PostService.deleteComment(user, postId, comment.id).catch(
                  (err) => {
                    // the delete failed on the server — put the comment back
                    updatePost(previousPost);
                    addToast("Failed to delete the comment");
                  }
                );
              }}
            />
          </div>
          <div
            className="text-xs font-light"
            dangerouslySetInnerHTML={{
              __html: md.render(comment.description),
            }}
          />
          <div className="PostImages">
            {comment.images && comment.images.length > 0 ? (
              <PostImage
                image={comment.images[0]}
                className={cx("object-cover object-center", {
                  "h-40 max-w-max rounded":
                    comment.images[0].split(".").pop() === "gif",
                })}
              />
            ) : (
              <></>
            )}
            <PostDocument post={comment} smallMargin />
          </div>
          <div className="mt-1 flex items-center justify-between">
            {/* left side icons */}
            <div className="flex items-center space-x-1">
              {/* reactions list */}
              {comment.reactions.details.map((reaction, index) => (
                <div
                  key={reaction.emoji + reaction.count + index}
                  className={cx(
                    "mr-2 flex cursor-pointer items-center rounded px-1 py-0.5 text-xs font-light",
                    {
                      "bg-background text-secondary-foreground/90":
                        reaction.isByMe,
                      "theme-bg-disable": !reaction.isByMe,
                    }
                  )}
                  onClick={(e) => {
                    // set reaction as this emoji
                    if (reaction.isByMe) {
                      handleRemoveReactToComment();
                    } else {
                      handleReactToComment(reaction.emoji);
                    }
                    // hit like api
                  }}
                  title={
                    "Reacted by " +
                    reaction.users.map((user) => user.name).join(", ")
                  }>
                  <span className="pr-1">{reaction.emoji}</span>
                  <span className="pl-1">{reaction.count}</span>
                </div>
              ))}
              {/* emoji icon */}
              <CustomDropDown
                alignment="left-1"
                dropdownClassName="-left-32 sm:left-1"
                button={
                  <IconButton2
                    icon="grin-alt"
                    size="sm"
                    iconClass="text-secondary-foreground/70"
                    className="mr-2 mt-1.5"
                    onClick={() => {
                      setIsEmojiPickerVisible(true);
                    }}
                  />
                }>
                {/* emoji picker */}
                {isEmojiPickerVisible && (
                  <EmojiPicker
                    emoji={null}
                    hidePlaceholder={true}
                    setEmoji={(emoji) => {
                      // set emoji
                      handleReactToComment(emoji);
                    }}
                    visible={true}
                  />
                )}
              </CustomDropDown>
              <div onClick={showSubComment}>
                {user ? (
                  <div className="flex cursor-pointer items-center">
                    <span className="text-xs font-light">
                      <I18>Reply</I18>
                    </span>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
            {commentRepliesArr && commentRepliesArr.length > 0 ? (
              <div onClick={showSubComment} className="mr-2">
                <span className="cursor-pointer text-xs font-light">
                  {`${commentRepliesArr.length} ${
                    commentRepliesArr.length > 1
                      ? lang.trans("Replies")
                      : lang.trans("Reply")
                  }`}
                </span>
              </div>
            ) : (
              <></>
            )}
          </div>
          {subCommentView ? (
            <>
              <div
                className={
                  commentRepliesArr.length > 0
                    ? "mr-2 rounded"
                    : "mr-2 rounded pb-2"
                }>
                {commentRepliesArr.length > 0 ? (
                  commentRepliesArr.map((reply, index) => (
                    <PostSubComment
                      post={post}
                      group={group}
                      user={user}
                      postId={post.id}
                      commentRepliesArr={commentRepliesArr}
                      comment={comment}
                      reply={reply}
                      index={index}
                      key={reply.id}
                      deleteSubComment={onSubCommentDelete}
                      updateComment={updateComment}
                      addToast={addToast}
                    />
                  ))
                ) : (
                  <></>
                )}
              </div>
            </>
          ) : (
            <></>
          )}
          {subCommentView ? (
            <div className="mr-4 pb-3">
              {!subCommentView ? (
                <div className="mr-2 mt-4 border-t border-border"></div>
              ) : (
                <></>
              )}
              <div className="my-1">
                <CreateComment
                  post={post}
                  user={user}
                  updatePost={onCommentUpdate}
                  commentId={comment.id}
                  isSubComment
                />
              </div>
            </div>
          ) : (
            <></>
          )}
          {isProcessing ? (
            <div className="processing">
              <Loader />
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
}

/**
 * Component to show a post comment
 * @param {*} param0
 * @returns
 */
function PostSubComment({
  post,
  user,
  group,
  comment,
  reply,
  index,
  commentRepliesArr,
  postId,
  deleteSubComment,
  updateComment = (e) => {},
  addToast,
}) {
  const [isEmojiPickerVisible, setIsEmojiPickerVisible] = useState(false);
  //delete reply confirmation
  const [visibleDeleteComment, setVisibleDeleteComment] = useState(false);

  const [isProcessing, setIsProcessing] = useState(false);

  const {
    profileModelState: { setShowProfileModel, setIdToViewProfile },
  } = useModel();

  // handle react to commnet
  const handleReactToComment = (emoji) => {
    PostService.addCommentReplyReaction(
      user,
      postId,
      comment.id,
      reply.id,
      emoji
    )
      .then(({ comment }) => {
        // update comment
        updateComment(comment);
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  // handle react to commnet
  const handleRemoveReactToComment = () => {
    PostService.removeCommentReplyReaction(user, postId, comment.id, reply.id)
      .then(({ comment }) => {
        // update comment
        updateComment(comment);
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  const sample = moment
    .duration(moment(new Date()).diff(moment(reply.createdAt)))
    .asDays();

  const postSubCommentDomId = comment.id
    ? "PostSubComment_" + comment.id
    : null;

  /**
   * Enable copy button on pre code parent
   */
  useEffect(() => {
    if (postSubCommentDomId) {
      const codeElemeents = document.querySelectorAll(
        `#${postSubCommentDomId} pre>code`
      );
      codeElemeents.forEach((codeElement) => {
        const preElement = codeElement.parentElement;
        preElement.style.position = "relative";
        const copyButtonElement = document.createElement("span");
        copyButtonElement.style.position = "absolute";
        copyButtonElement.style.top = "0px";
        copyButtonElement.style.right = "5px";
        copyButtonElement.style.cursor = "pointer";
        copyButtonElement.innerText = "Copy";
        copyButtonElement.onclick = async () => {
          try {
            await navigator.clipboard.writeText(codeElement.innerText);
            return;
          } catch (error) {
            console.error("Cannot copy to clipboard, trying legacy");
          }
          const copyElem = document.createElement("textarea");
          copyElem.value = codeElement.innerText;
          document.body.appendChild(copyElem);
          copyElem.select();
          document.execCommand("copy");
          document.body.removeChild(copyElem);
          addToast("Copied to clipboard");
        };
        preElement.appendChild(copyButtonElement);
      });
    }
  }, [comment.description]);

  return (
    <>
      <div
        key={reply.id}
        id={postSubCommentDomId}
        className="zm-auto mt-2 rounded border-t border-border pl-1 pt-1">
        <div className="flex items-center justify-between">
          <div className="text-sm">
            <Avatar
              user={reply.createdBy}
              extraInfo={formatTime(reply.createdAt)}
              size={36}
              className="cursor-pointer"
              subCommentAvatar
              onClick={(e) => {
                // open the user page
                // window.open(
                //   createUserWallPageRoute(reply.createdBy.id, "activity")
                // );
                setIdToViewProfile(reply.createdBy.id);
                setShowProfileModel(true);
              }}
            />
          </div>
          <IconMenu2
            icon="menu-dots"
            hideOnEmpty
            actions={[
              {
                label:
                  (user && reply.createdBy && reply.createdBy.id === user.id) ||
                  post.canDeleteReply
                    ? "Delete"
                    : "",
                onClick: (e) => {
                  setIsProcessing(true);
                  setVisibleDeleteComment(true);
                },
                actionType: ActionType.alert,
                icon: "trash",
              },
            ]}
          />
          <ActionModal
            active={visibleDeleteComment}
            setActive={setVisibleDeleteComment}
            header="Delete Reply"
            title="Are you sure you want to delete this reply?"
            onSubmit={(e) => {
              PostService.deleteSubComment(user, postId, comment.id, reply.id)
                .then((response) => {
                  deleteSubComment(response.commentReply);
                  setIsProcessing(false);
                  addToast("Reply Deleted");
                })
                .catch((err) => {
                  setIsProcessing(false);
                });
            }}
          />
        </div>
        <div className="pl-12">
          <div
            className="pb-1 text-xs font-light"
            dangerouslySetInnerHTML={{ __html: md.render(reply.description) }}
          />
          <div className="PostSubCommentDocumentPreview">
            {reply.documents.length > 0 ? (
              <PostSubCommentDocumentPreview reply={reply} smallMargin />
            ) : (
              <></>
            )}
          </div>
          {/* post reply reactions */}
          <div className="mt-1 flex items-center justify-between">
            {/* left side icons */}
            <div className="flex items-center">
              {/* reactions list */}
              {reply.reactions.details.map((reaction, index) => (
                <div
                  key={reaction.emoji + reaction.count + index}
                  className={cx(
                    "mr-2 flex cursor-pointer items-center rounded px-1 py-0.5 text-xs font-light",
                    {
                      "theme-text-on-default bg-background": reaction.isByMe,
                      "theme-bg-disable": !reaction.isByMe,
                    }
                  )}
                  onClick={(e) => {
                    // set reaction as this emoji
                    if (reaction.isByMe) {
                      handleRemoveReactToComment();
                    } else {
                      handleReactToComment(reaction.emoji);
                    }
                    // hit like api
                  }}
                  title={
                    "Reacted by " +
                    reaction.users.map((user) => user.name).join(", ")
                  }>
                  <span className="pr-1">{reaction.emoji}</span>
                  <span className="pl-1">{reaction.count}</span>
                </div>
              ))}
              {/* emoji icon */}
              <CustomDropDown
                alignment=""
                dropdownClassName="-left-24 sm:left-1"
                button={
                  <IconButton2
                    icon="grin-alt"
                    size="md"
                    iconClass="text-secondary-foreground/70"
                    className="mt-1 h-4"
                    onClick={() => {
                      setIsEmojiPickerVisible(true);
                    }}
                  />
                }>
                {/* emoji picker */}
                {isEmojiPickerVisible && (
                  <EmojiPicker
                    emoji={null}
                    hidePlaceholder={true}
                    setEmoji={(emoji) => {
                      // set emoji
                      handleReactToComment(emoji);
                    }}
                    visible={true}
                  />
                )}
              </CustomDropDown>
            </div>
          </div>
        </div>
        <div
          className={
            commentRepliesArr && commentRepliesArr.length - 1 === index
              ? ""
              : "ml-12 mt-2"
          }
        />
        {isProcessing ? (
          <div className="processing">
            <Loader />
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

/**
 * Component to show a post comment
 * @param {*} param0
 * @returns
 */
export function PostSubCommentDocumentPreview({
  reply,
  activityType = "",
  isActivity = false,
}) {
  const [subCommentImageToBePreviewed, setSubCommentImageToBePreviewed] =
    useState(null);

  const videoFormat = ["mp4", "mov", "webm", "ogg"];
  // Note: `blob` is added here because of the way we are uploading the gif in replay of a comment
  const imageFormat = ["png", "jpg", "jpeg", "gif", "blob"];
  const audioFormat = ["wav", "mp3", "aac", "amr"];

  const [fileType, setFileType] = useState("");

  useEffect(() => {
    if (activityType == "" || activityType == "comment-reply") {
      setFileType(
        reply.documents.length > 0
          ? reply.documents[0].location.split(".").pop()
          : ""
      );
    } else if (reply.images && reply.images.length > 0) {
      setFileType(reply.images[0].split(".").pop());
    } else if (reply.document && reply.document !== "") {
      setFileType(reply.document.split(".").pop());
    }
  }, []);

  return (
    <>
      {subCommentImageToBePreviewed &&
      imageFormat.includes(subCommentImageToBePreviewed.split(".").pop()) ? (
        <div
          className="PostImageFullPreview"
          onClick={(e) => {
            setSubCommentImageToBePreviewed(null);
          }}>
          <div className="holder">
            <img src={subCommentImageToBePreviewed} alt="Preview" />
            <IconButton
              icon="plus"
              rotate={45}
              className="close-button"
              onClick={(e) => {
                setSubCommentImageToBePreviewed(null);
              }}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      {
        // Post preview and activity comment-reply preview
        activityType === "" || activityType === "comment-reply" ? (
          <div key={reply.id} className="PostComment m-auto mt-2">
            {videoFormat.includes(fileType) && reply.documents.length > 0 ? (
              <div className="mt-2 py-1 pl-12 pr-4">
                <video
                  className="m-0 h-64 w-full rounded-md object-cover"
                  controls
                  controlsList="nodownload">
                  <source src={reply.documents[0].location} />
                </video>
              </div>
            ) : audioFormat.includes(fileType) && reply.documents.length > 0 ? (
              <>
                <div className="mt-2 py-1 pl-12 pr-4">
                  <audio
                    className="m-0 w-full rounded-md py-1"
                    controls
                    controlsList="nodownload">
                    <source src={reply.documents[0].location} />
                  </audio>
                </div>
              </>
            ) : imageFormat.includes(fileType) && reply.documents.length > 0 ? (
              <div className="PostImage relative w-full pl-12 pr-2">
                <img
                  onClick={(e) => setSubCommentImageToBePreviewed(e.target.src)}
                  alt=""
                  className={cx(
                    "w-full rounded-md object-cover object-center",
                    {
                      "h-40 max-w-max rounded":
                        reply.documents[0].location.split(".").pop() === "gif",
                      "h-60":
                        !reply.documents[0].location.split(".").pop() === "gif",
                    }
                  )}
                  src={reply.documents[0].location}
                />
              </div>
            ) : reply.documents.length > 0 ? (
              <div className="relative m-2 ml-12">
                <a
                  download
                  target="_blank"
                  rel="noreferrer"
                  href={
                    reply.documents.length > 0 && !isActivity
                      ? reply.documents[0].location
                      : "/#"
                  }
                  title="Open file"
                  className="flex items-center space-x-2 rounded border-2 border-border px-4 py-2 font-semibold">
                  <UIcon icon="document" className="h-9 text-3xl" />
                  <div className="flex flex-grow items-center justify-between space-x-4">
                    <div className="items-center">
                      <div>
                        {reply.documents.length > 0
                          ? reply.documents[0].name
                          : ""}
                      </div>
                      <div className="text-xs uppercase">
                        {reply.documents.length > 0
                          ? reply.documents[0].name.split(".").pop()
                          : ""}
                      </div>
                    </div>
                    <span className="flex-none">
                      <UIcon icon="download" className="text-xl" />
                    </span>
                  </div>
                </a>
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : (
          // for post-comment
          <div key={reply.id} className="PostComment m-auto mt-2">
            {reply.images.length > 0 && imageFormat.includes(fileType) ? (
              <div className="PostImage relative w-full pl-12 pr-2">
                <img
                  className={cx(
                    "w-full rounded-md object-cover object-center",
                    {
                      "h-40 max-w-max rounded":
                        reply.images[0].split(".").pop() === "gif",
                      "h-60": !reply.images[0].split(".").pop() === "gif",
                    }
                  )}
                  src={reply.images[0]}
                  alt=""
                />
              </div>
            ) : reply.document && videoFormat.includes(fileType) ? (
              <div className="mt-2 py-1 pl-12 pr-4">
                <video
                  className="m-0 h-64 w-full rounded-md object-cover"
                  controls>
                  <source src={reply.document} />
                </video>
              </div>
            ) : reply.document && reply.document !== "" ? (
              <div className="relative m-2 ml-12">
                <a
                  download
                  target="_blank"
                  rel="noreferrer"
                  href="/#"
                  title="Open file"
                  className="flex items-center space-x-2 rounded border-2 border-border px-4 py-2 font-semibold">
                  <UIcon icon="document" className="h-9 text-3xl" />
                  <div className="flex flex-grow items-center justify-between space-x-4">
                    <div className="items-center">
                      <div>
                        {reply.documentName !== "" ? reply.documentName : ""}
                      </div>
                      <div className="text-xs uppercase">
                        {reply.document && reply.document !== ""
                          ? reply.document.split(".").pop()
                          : ""}
                      </div>
                    </div>
                    <span className="flex-none">
                      <UIcon icon="download" className="text-xl" />
                    </span>
                  </div>
                </a>
              </div>
            ) : (
              <></>
            )}
          </div>
        )
      }
    </>
  );
}
